import React from "react"
import "./LearnerAuthBootScreen.style.scss"

interface LearnerAuthBootScreenProps {
  title?: string
  hint?: string
  brand?: string
}

const LearnerAuthBootScreen = ({
  title = "Checking your session",
  hint = "Getting your practice space ready…",
  brand = "Learner",
}: LearnerAuthBootScreenProps) => {
  return (
    <div
      data-theme="learner"
      className="learner-auth-boot"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={title}
    >
      <div className="learner-auth-boot__glow learner-auth-boot__glow--a" aria-hidden />
      <div className="learner-auth-boot__glow learner-auth-boot__glow--b" aria-hidden />

      <div className="learner-auth-boot__content">
        <p className="learner-auth-boot__brand">{brand}</p>

        <div className="learner-auth-boot__ring" aria-hidden>
          <span className="learner-auth-boot__ring-track" />
          <span className="learner-auth-boot__ring-arc" />
        </div>

        <h1 className="learner-auth-boot__title">{title}</h1>
        <p className="learner-auth-boot__hint">{hint}</p>
      </div>
    </div>
  )
}

export default LearnerAuthBootScreen
